function limitedText30(text) {
  if (text) {
    return text.length > 30 ? text.slice(0, 30) + "…" : text;
  } else {
    return text
  }
}

export default limitedText30
